import { ACTIONS } from "../../Models/ENUM";
import { NotifInfo } from "../../UTIL/NOTIFINFO";
import AvatarInstance from "../AVATAR/AvatarInstance";
import CONQUER from "../CONQUER";

class Notification
{
    private conquer     : CONQUER;
    

    constructor( instance:CONQUER )
    {
        this.conquer        = instance;
    };
 
    public async set( data:any ) : Promise<any>
    {
        var value   = await this.conquer.do<NotifInfo>( ACTIONS.NOTIFICATION_SET, { message: data.message, receiverId: data.receiverId, timestamp: data.timestamp } );

        return Promise.resolve( value );
    }
}

export default Notification;